"use strict";
var e, r;
function t() {
  return r || (r = 1, e = Object), e;
}
export {
  t as __require
};
//# sourceMappingURL=index.es303.js.map
